import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { documentHistoryComponent } from './documentHistory.component';
import { VersionActionsModule } from './../components/versionActions.module';
import { DocumentsDetailModule } from './../components/documentsDetail.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { UserModule } from '../../user/user/user.module';
import { TranslateModule } from '@ngx-translate/core';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { TableModule } from 'primeng-lts/table';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { TooltipModule } from 'primeng-lts/tooltip';

@NgModule({
    declarations: [documentHistoryComponent],
    imports: [TranslateModule, CommonModule,
        FormsModule,
        FormPlycaModule,
        RouterModule,

        VersionActionsModule,
        TableModule,
        DocumentsDetailModule, WaitLoadingModule, UserModule, ScrollPanelModule, SubHeaderModule,
        TooltipModule]
})

export class DocumentHistoryModule { }
